import "./App.css";

import React from "react";
import Routers from "./routes";
import { BrowserRouter as Router } from "react-router-dom";

function App() {
  return (
    <>
      <Router>
        <Routers></Routers>
      </Router>
    </>
  );
}

export default App;
